// store/modules/mensagem-store.js
export default {
  namespaced: true,
  state: {
    toasts: []
  },
  mutations: {
    adicionarToast(state, toast) {
      state.toasts.push(toast)
    },
    limparToasts(state) {
      state.toasts = []
    }
  },
  actions: {
    exibirToast({ commit }, { titulo, mensagem, variant = 'info', tempo = 100 }) {
      commit('adicionarToast', { titulo, mensagem, variant, tempo })
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/mensagem-store.js